var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoErr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 137,
    viewBox: "0 0 342 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2501_18)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1492 13H37.9536L40.5188 15.5652V27.292L37.9536 29.8572L40.5188 32.4224V44.1492L37.9536 46.7144H16.1492L15.7827 39.0187H17.0653V20.6957H15.7827L16.1492 13ZM27.3262 20.6957V27.1087L30.2579 26.0094V20.6957H27.3262ZM27.3262 34.8044V39.0187H30.2579V33.705L27.3262 34.8044Z",
    fill: "url(#paint0_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9632 13H96.7676L97.1341 24.91H89.4384L89.072 20.6957H86.1403V27.1087L89.072 26.0094V33.705L86.1403 34.8044V39.0187H87.4229L87.0564 46.7144H74.9632L74.5968 39.0187H75.8794V20.6957H74.5968L74.9632 13Z",
    fill: "url(#paint1_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.347 13H101.543L101.177 20.6957H102.459V39.0187H101.177L101.543 46.7144H113.636L114.003 39.0187H112.72V34.8044L115.652 33.705V26.0094L112.72 27.1087V20.6957H115.652L116.018 24.91H123.714L123.347 13Z",
    fill: "url(#paint2_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.874 33.705L138.942 34.8044V39.0187H139.492L139.125 46.7144H127.765L127.399 39.0187H128.681V15.5652L131.246 13H149.569L152.135 15.5652V39.0187H153.417L153.051 46.7144H141.691L141.324 39.0187H141.874V33.705ZM138.942 27.1087L141.837 26.0094V20.6957H138.942V27.1087Z",
    fill: "url(#paint3_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.909 13H157.816L157.45 20.6957H158.732V39.0187H157.45L157.816 46.7144H179.621L179.987 34.8044H172.291L171.925 39.0187H168.993V20.6957H170.276L169.909 13Z",
    fill: "url(#paint4_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.595 13H204.881L207.447 15.5652H207.483V44.1492L204.918 46.7144H186.595L184.03 44.1492V15.5652L186.595 13ZM194.291 39.0187H197.222V20.6957H194.291V39.0187Z",
    fill: "url(#paint5_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.903 65.6854C322.201 64.6322 314.659 62.3496 314.659 62.3496L316.063 60.091C313.672 60.4601 311.827 60.7574 309.047 62.143L309.046 62.1436C309.045 62.144 309.043 62.1445 309.042 62.1451L309.041 62.146L309.041 62.1466C304.528 64.5085 302.339 66.7531 301.633 68.6873C301.489 69.0835 301.406 69.4652 301.379 69.8335C301.27 71.2766 302.004 72.4951 303.147 73.3886C304.717 74.6187 307.058 75.2379 309.048 74.9888C309.048 74.9888 305.364 78.4996 300.102 76.7442C298.298 76.088 296.84 74.8362 295.872 73.273C292.147 67.2612 294.415 57.5375 305.445 53.442C305.445 53.442 290.454 30.0479 270.458 21.6218L238.535 31.1021L242.569 33.9107L218.013 42.3368L219.942 43.5661L181.002 60.5933C181.002 60.5933 182.932 68.6683 174.688 79.2027C174.688 79.2027 180.301 78.4996 186.616 68.3181C186.616 68.3181 182.581 88.682 169.074 90.0864L164.205 118H181.394L178.623 112.89C178.623 112.89 177.384 103.938 177.842 103.078C179.012 100.884 180.182 100.518 184.599 99.1362C185.482 98.8598 186.496 98.5427 187.665 98.1623C189.085 97.7005 190.634 97.4543 192.298 97.1896C198.862 96.1462 207.232 94.8156 216.607 78.8525C216.607 78.8525 214.677 88.3318 212.221 91.3165C217.833 90.7895 222.569 98.8644 222.569 98.8644L243.036 98.3689L240.461 78.8525L248.786 100.764L255.223 100.681L264.809 117.999L279.05 117.823L274.456 112.734L271.333 101.673L278.882 99.0585L282.559 105.359L284.488 100.619L290.451 111.855L293.258 107.29C293.258 107.29 303.958 112.381 305.712 112.381C307.466 112.381 323.252 93.9483 326.409 83.9428C326.409 83.9428 323.603 66.7396 322.901 65.6845L322.903 65.6854ZM308.901 90.6712C308.901 90.6712 307.163 92.0963 305.445 90.7867C305.445 90.7867 305.488 91.5025 304.913 92.2461C304.913 92.2461 303.556 86.2416 305.616 84.3634C305.616 84.3634 309.328 86.2262 310.516 92.1505C310.516 92.1505 309.706 90.655 308.901 90.6712Z",
    fill: "url(#paint6_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.488 99.676C193.488 99.676 201.697 99.5234 205.25 95.8366V95.8357L214.853 112.557L220.992 117.999L202.998 117.218L193.488 99.676Z",
    fill: "url(#paint7_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.035 101.767V117.999H247.522L243.863 112.733L244.028 101.767H231.035Z",
    fill: "url(#paint8_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6388 13.3665H44.912L44.5456 21.0621H45.8282V44.1492L48.3934 46.7144H66.7164L69.2817 44.1492V21.0621H70.5643L70.1978 13.3665H58.4711L58.1046 21.0621H59.0208V39.0187H56.0891V21.0621H57.0052L56.6388 13.3665Z",
    fill: "url(#paint9_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.892 51.6766H121.265L120.544 75.1061H132.439L133.16 66.8157H137.486V102.861H134.963L135.683 118H159.473L160.194 102.861H157.671V66.8157H161.997L162.717 75.1061H174.612L173.892 51.6766Z",
    fill: "url(#paint10_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1399 51.6766H114.034L114.755 75.1061H99.6157L98.8947 66.8157H93.1275V79.4315L98.8947 77.2688V92.4078L93.1275 94.5706V102.861H98.8947L99.6157 94.5706H114.755L114.034 118H71.1399L70.419 102.861H72.9421V66.8157H70.419L71.1399 51.6766Z",
    fill: "url(#paint11_linear_2501_18)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6138 51.6766H16.7199L15.999 66.8157H18.5222V102.861H15.999L16.7199 118H59.6138L64.6601 112.954V89.8847L59.6138 84.8383L64.6601 79.792V56.723L59.6138 51.6766ZM38.7075 79.4315V66.8157H44.4748V77.2688L38.7075 79.4315ZM38.7075 102.861V94.5706L44.4748 92.4078V102.861H38.7075Z",
    fill: "url(#paint12_linear_2501_18)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2501_18",
    x: 0.292519,
    y: 0.607843,
    width: 341.607,
    height: 135.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.09804
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.7451
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2501_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2501_18",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.54902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow_2501_18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2501_18",
    x1: 171.096,
    y1: 13,
    x2: 171.096,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoErr);
export default ForwardRef;